// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import server from './axios/api'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import request from './axios/request'
import validator from './assets/validateRules';

import mqtt from 'mqtt'

import md5 from 'js-md5';
import apiServer from './utils/api';
import store from './utils/store';

import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.qs = qs
Vue.prototype.axios = axios;
Vue.prototype.server = server; //引入接口服务
Vue.prototype.validator = validator; //引入校验规则

Vue.prototype.md5 = md5; //引入md5加密
Vue.prototype.apiServer = apiServer; //引入请求
Vue.prototype.store = store; //引入配置
Vue.prototype.mqtt = mqtt;	//引入mqtt

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render:h => h(App),
  components: { App },
  template: '<App/>',
})

//路由守卫
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requireAuth)){
		if (localStorage.getItem('user')) {
			next();
		}else {
			ElementUI.MessageBox({
				title:'您未登录',
				message:'请您登录后操作'
			},() => {
				//+---------------避免重复重定向------------
				if(from.fullPath == '/') {
					window.location.href = window.location.href+"?auth=0&redirect="+to.fullPath
					return false;
				}else{
					next({
						path:'/',
						query: {auth:0,redirect: to.fullPath}
					});
				};
			});
		}
	}else {
		next();
	}
});



// WEBPACK FOOTER //
// ./src/main.js